<template>
  <UserCommentView
    :id
    :average-rate
    :comment
    :country-code
    :customer
    :display-seller
    :language-code
    :product
    :purchase-date="product.purchasedAt"
    :review-date="createdAt"
    :sales-order-item
    :seller
    :track-review-impression="true"
    :trackingData="{
      onClick: clickTrackingData,
      onImpression: impressionTrackingData,
    }"
    :translated-comment
  >
    <PhotosSlider
      v-if="showPhotos"
      data-test="photos-slider"
      v-bind="props"
      :trackingData="clickTrackingData"
    />
  </UserCommentView>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import UserCommentView from '@backmarket/nuxt-layer-reviews/review-display/UserCommentView.vue'

import { ROUTES } from '../../../route-names'
import type { DisplayedReview } from '../../models/reviews'
import PhotosSlider from '../PhotosSlider/PhotosSlider.vue'

const props = withDefaults(
  defineProps<
    DisplayedReview & {
      position: number
      showPhotos?: boolean
    }
  >(),
  { showPhotos: true },
)

const route = useRoute()

const displaySeller = route.name !== ROUTES.PAGES.MERCHANT

const impressionTrackingData = {
  reviewPosition: props.position,
  pageType: route.name as string,
  reviewPhotos: Boolean(props.attachments?.length),
  photosReviewsDisplayed: (props.attachments || []).length,
  reviewComment: Boolean(props.comment),
  zone: 'reviews_list',
}

const clickTrackingData = {
  zone: `review_position_${props.position}`,
  page_type: route.name as string,
}
</script>
